// extracted by mini-css-extract-plugin
export default {"AddOneModal":"g8csxp34DMtZ9XuQA58C","Content":"qVf8Mphph8kMoWGHdMkh","Header":"qn6o8mDeJgpO0odczQ03","Center":"nlLL6Eh1On0A9nlKt6us","Right":"ziFS6XLrST9ZlZmkh_4l","List":"BNAyfP98xy8sIgy0kNRn","ImageBox":"socEvVY7pcIdox2wLugP","Image":"X7lDgyITBmzGHexV6pUK"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"AddOneModal\":\"g8csxp34DMtZ9XuQA58C\",\"Content\":\"qVf8Mphph8kMoWGHdMkh\",\"Header\":\"qn6o8mDeJgpO0odczQ03\",\"Center\":\"nlLL6Eh1On0A9nlKt6us\",\"Right\":\"ziFS6XLrST9ZlZmkh_4l\",\"List\":\"BNAyfP98xy8sIgy0kNRn\",\"ImageBox\":\"socEvVY7pcIdox2wLugP\",\"Image\":\"X7lDgyITBmzGHexV6pUK\"}";
        // 1791291354594
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  